/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_CatInputs */

const en_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const ar_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#سيو`)
};

const bn_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const de_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const es_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const fr_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const pt_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const zh_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const tr_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const ru_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const pl_svc_programmatic_seo_cat = /** @type {(inputs: Svc_Programmatic_Seo_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

/**
* | output |
* | --- |
* | "#SEO" |
*
* @param {Svc_Programmatic_Seo_CatInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_cat = /** @type {((inputs?: Svc_Programmatic_Seo_CatInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_CatInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_cat(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_cat(inputs)
	if (locale === "de") return de_svc_programmatic_seo_cat(inputs)
	if (locale === "es") return es_svc_programmatic_seo_cat(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_cat(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_cat(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_cat(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_cat(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_cat(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_cat(inputs)
	return en_svc_programmatic_seo_cat(inputs)
});
export { svc_programmatic_seo_cat as "svc_programmatic-seo_cat" }